/**
 * Chart colours as CSS variables, so Recharts paints with the active theme's palette (light and dark) and no chart
 * carries a hex value. Pick a tone by meaning — gain/loss, healthy/failing — not by looks.
 */
export type ChartTone = 'accent' | 'success' | 'danger' | 'warning' | 'muted' | 'purple' | 'teal';

export const TONE_COLOR: Record<ChartTone, string> = {
  accent: 'var(--color-accent)',
  success: 'var(--color-success)',
  danger: 'var(--color-danger)',
  warning: 'var(--color-warning)',
  muted: 'var(--color-faint)',
  purple: 'var(--color-purple)',
  teal: 'var(--color-teal)',
};

/** Background swatch class per tone, for legends and tooltips. */
export const TONE_SWATCH: Record<ChartTone, string> = {
  accent: 'bg-accent',
  success: 'bg-success',
  danger: 'bg-danger',
  warning: 'bg-warning',
  muted: 'bg-faint',
  purple: 'bg-purple',
  teal: 'bg-teal',
};

/** Tones for series that carry no meaning of their own (series 1, 2, 3…). */
export const SERIES_TONES: readonly ChartTone[] = ['accent', 'teal', 'purple', 'warning', 'success', 'danger'];

/** A signed value's tone: gains green, losses red, zero muted. */
export function signTone(value: number): ChartTone {
  return value > 0 ? 'success' : value < 0 ? 'danger' : 'muted';
}
